import PageHeader from "@/components/PageHeader";
import Matchmaker from "@/sections/Matchmaker";
import Feedback from "@/sections/Feedback";

export default function ConciergePage() {
  return (
    <>
      <PageHeader silk={2}
        testid="concierge-header"
        eyebrow="Çöpçatan &amp; Konsiyerj"
        titleLines={["Bir algoritma listesi değil,", "bir insan dokunuşu."]}
        lede="Five Star'da sürecin yalnızca ekrandan ibaret değildir. Çöpçatanın, seçimlerini ve geri bildirimlerini takip eder; ihtiyaç duyduğunda yönlendirme alırsın."
      />
      <Matchmaker showLink={false} />
      <Feedback />
    </>
  );
}
